import React, { useEffect,useRef, useState } from 'react';
import axios from 'axios';
import Nominee_Afso_cards from './Nominee_Afso_cards'; 
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';


const Nominee_Cards_Abstract = () => {
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDistCode, setSelectedDistCode] = useState(null); 
  const [downloading, setDownloading] = useState(false);
  const drillDownRef = useRef(null);
  const [selectedDistName, setSelectedDistName] = useState('');
 const [sessionExpired, setSessionExpired] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();


  useEffect(() => {

        axios
          .get(`${process.env.REACT_APP_URL}/api/ekyc-to-be-done/session-info`, { withCredentials: true })
          .then(res => {
            setUserRole(res.data.userRole);
            
          })
          .catch(() => {
            
            setSessionExpired(true);
            setUserRole("1"); 
          });

    axios.get(`${process.env.REACT_APP_URL}/api/nominee/abstract`, { withCredentials: true })
      .then((response) => {
         if (typeof response.data === 'string') {
        setData([]);                    // Set empty array
        setError(response.data);        // Show message as "error" (or use a new state)
        setLoading(false);
        return;
      }
       setData(response.data);
      calculateTotals(response.data);
      setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch nominee data.");
        setLoading(false);
      });
  }, []);

  
useEffect(() => {
  if (selectedDistCode && drillDownRef.current) {
    drillDownRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [selectedDistCode]);

const handleExcelDownload = async (status) => {
  setDownloading(true);
  try {
    const url = `${process.env.REACT_APP_URL}/api/nominee/district/excel?status=${status}`;

    const response = await axios.get(url, {
      responseType: "blob",
    });

   const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
const downloadUrl = window.URL.createObjectURL(blob);  
const link = document.createElement('a');
link.href = downloadUrl;

const contentDisposition = response.headers["content-disposition"];
let filenameMap = {
  1: "Admin_Approved.xls",
  2: "Admin_Approved_Tagged.xls",
  3: "Admin_Approved_Not_Tagged.xls",
  4: "RC_Base.xls",
  5: "FPS_Base.xls",
  6: "Total.xls"
};

let filename = filenameMap[status] || "Nominee_Cards.xls";

if (contentDisposition) {
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  if (match && match[1]) {
    filename = match[1];
  }
}


link.download = filename;
link.click();

link.remove();
window.URL.revokeObjectURL(downloadUrl); 

  } catch (error) {
    console.error("Download failed", error);
    alert("Download failed. Please try again.");
  } finally {
    setDownloading(false);
  }
};


  const calculateRowTotal = (row) => {
    return (
      (row.admRc || 0) +
      (row.admTagRc || 0) +
      (row.admNotTagRc || 0) +
      (row.rcAgedNominee || 0) +
      (row.rcFailNominee || 0) +
      (row.rcOtheNominee || 0) +
      (row.rcNominee || 0) +
      (row.fpsAgedNominee || 0) +
      (row.fpsFailNominee || 0) +
      (row.fpsLepNominee || 0) +
      (row.fpsBedNominee || 0) +
      (row.fpsNominee || 0) +
      (row.nomineeCards || 0) +
      (row.nomDrawnCards || 0) +
      (row.selfDrawn || 0) +
      (row.vroDrawn || 0)
    );
  };

  const calculateTotals = (rows) => {
    const totalObj = {
      admRc: 0,
      admTagRc: 0,
      admNotTagRc: 0,
      rcAgedNominee: 0,
      rcFailNominee: 0,
      rcOtheNominee: 0,
      rcNominee: 0,
      fpsAgedNominee: 0,
      fpsFailNominee: 0,
      fpsLepNominee: 0,
      fpsBedNominee: 0,
      fpsNominee: 0,
      nomineeCards: 0,
      nomDrawnCards: 0,
      selfDrawn: 0,
      vroDrawn: 0,
    };

    rows.forEach(row => {
      Object.keys(totalObj).forEach(key => {
        totalObj[key] += row[key] || 0;
      });
    });

    setTotals(totalObj);
  };

  const totalOfTotals = calculateRowTotal(totals);

  return (
    
    <div className="wrapper">
      <br></br>
      <h2 style={{ 
    textAlign: "center", 
    color: "#111111ff", 
    fontSize: "18px", 
    textDecoration: "underline" 
  }}>
    District wise cards mapped with Nominee Abstract
  </h2>
         {loading && (
            <div style={{ textAlign: 'center' }}>
            <CircularProgress size={40} />
            </div>
                      )}
      {/* {loading && <p>Loading...</p>} */}

      {!loading && !error && data.length > 0 && (
        <>
<table style={{ width: '80%', margin: '0 auto', borderCollapse: 'collapse' }}>
            <thead>
              <tr className="tableheader">
                <th rowSpan={3}>Sl.No</th>
                <th rowSpan={3}>District</th>
                <th rowSpan={2} colSpan={3}>Admin Approved</th>
                <th colSpan={10}>Cards With Nominee</th>
                <th rowSpan={3}>Total<br />Drawn Cards</th>
                <th rowSpan={3}>Self<br />Drawn Cards</th>
                <th rowSpan={3}>Nominee<br />Drawn Cards</th>
                {/* <th rowSpan={3}>Total</th> */}
              </tr>
              <tr className="tableheader">
                <th colSpan={4}>RC Base</th>
                <th colSpan={5}>FPS Base</th>
                <th rowSpan={2}>Total</th>
              </tr>
              <tr className="tableheader">
                <th>Approved</th>
                <th>Tagged<br />Nominee</th>
                <th>Not Tagged<br />Nominee</th>
                <th>Aged</th>
                <th>Failed</th>
                <th>Others</th>
                <th>Total</th>
                <th>Aged</th>
                <th>Failed</th>
                <th>Leprosy</th>
                <th>Bedridden</th>
                <th>Total</th> 
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <span
                      style={{ cursor: "pointer", color: "black", textDecoration: "underline" }}
                     onClick={() => {
                          setSelectedDistCode(row.distCode);
                          setSelectedDistName(row.distNameEn); 
                        }}
                    >
                      {row.distNameEn}
                    </span>
                  </td>
                  <td align="right">{row.admRc}</td>
                  <td align="right">{row.admTagRc}</td>
                  <td align="right">{row.admNotTagRc}</td>
                  <td align="right">{row.rcAgedNominee}</td>
                  <td align="right">{row.rcFailNominee}</td>
                  <td align="right">{row.rcOtheNominee}</td>
                  <td align="right">{row.rcNominee}</td>
                  <td align="right">{row.fpsAgedNominee}</td>
                  <td align="right">{row.fpsFailNominee}</td>
                  <td align="right">{row.fpsLepNominee}</td>
                  <td align="right">{row.fpsBedNominee}</td>
                  <td align="right">{row.fpsNominee}</td>
                  <td align="right">{row.nomineeCards}</td>
                  <td align="right">{row.nomDrawnCards}</td>
                  <td align="right">{row.selfDrawn}</td>
                  <td align="right">{row.vroDrawn}</td>
                  {/* <td align="right">{calculateRowTotal(row)}</td> */}
                </tr>
              ))}
            </tbody>
           <tfoot>
  {userRole === '0' || userRole === null || userRole === '' ? (
    <tr
      className="tableheader"
      style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}
    >
      <td colSpan={2} align="center">Total</td>
      <td align="right">{totals.admRc}</td>
      <td align="right">{totals.admTagRc}</td>
      <td align="right">{totals.admNotTagRc}</td>
      <td align="right">{totals.rcAgedNominee}</td>
      <td align="right">{totals.rcFailNominee}</td>
      <td align="right">{totals.rcOtheNominee}</td>
      <td align="right">{totals.rcNominee}</td>
      <td align="right">{totals.fpsAgedNominee}</td>
      <td align="right">{totals.fpsFailNominee}</td>
      <td align="right">{totals.fpsLepNominee}</td>
      <td align="right">{totals.fpsBedNominee}</td>
      <td align="right">{totals.fpsNominee}</td>
      <td align="right">{totals.nomineeCards}</td>
      <td align="right">{totals.nomDrawnCards}</td>
      <td align="right">{totals.selfDrawn}</td>
      <td align="right">{totals.vroDrawn}</td>
    </tr>
  ) : (
    <tr
      className="tableheader"
      style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}
    >
      <td colSpan={2} align="center">Total</td>

      <td align="right">
        {totals.admRc > 0 ? (
          <span
            style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => handleExcelDownload(1)}
          >
            {totals.admRc}
          </span>
        ) : totals.admRc}
      </td>

      <td align="right">
        {totals.admTagRc > 0 ? (
          <span
            style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => handleExcelDownload(2)}
          >
            {totals.admTagRc}
          </span>
        ) : totals.admTagRc}
      </td>

      <td align="right">
        {totals.admNotTagRc > 0 ? (
          <span
            style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => handleExcelDownload(3)}
          >
            {totals.admNotTagRc}
          </span>
        ) : totals.admNotTagRc}
      </td>

      <td align="right">{totals.rcAgedNominee}</td>
      <td align="right">{totals.rcFailNominee}</td>
      <td align="right">{totals.rcOtheNominee}</td>

      <td align="right">
        {totals.rcNominee > 0 ? (
          <span
            style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => handleExcelDownload(4)}
          >
            {totals.rcNominee}
          </span>
        ) : totals.rcNominee}
      </td>

      <td align="right">{totals.fpsAgedNominee}</td>
      <td align="right">{totals.fpsFailNominee}</td>
      <td align="right">{totals.fpsLepNominee}</td>
      <td align="right">{totals.fpsBedNominee}</td>

      <td align="right">
        {totals.fpsNominee > 0 ? (
          <span
            style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => handleExcelDownload(5)}
          >
            {totals.fpsNominee}
          </span>
        ) : totals.fpsNominee}
      </td>

      <td align="right">
        {totals.nomineeCards > 0 ? (
          <span
            style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => handleExcelDownload(6)}
          >
            {totals.nomineeCards}
          </span>
        ) : totals.nomineeCards}
      </td>

      <td align="right">{totals.nomDrawnCards}</td>
      <td align="right">{totals.selfDrawn}</td>
      <td align="right">{totals.vroDrawn}</td>
    </tr>
  )}
</tfoot>

          </table>

                  {selectedDistCode && (
          <div style={{ marginTop: "30px" }} ref={drillDownRef}>
<Nominee_Afso_cards distCode={selectedDistCode} districtName={selectedDistName} />
          </div>
        )}

        </>
      )}

{!loading && data.length === 0 && (
           <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
             <p style={{ fontSize: '18px' }} className='response'>
               {error || 'No data found'}
             </p>
           </div>
      )}
      <br/>         <br/>
     <br/>
      <br/>
     <br/> 
      <br/>
     <br/>
      <br/>

    </div>
 
  );
};

export default Nominee_Cards_Abstract;